<template>
  <div>
    <div class="homePop">
      <div class="pxindBox">
        <img @click="jumpCourseDetail" class="pxind" :src="popupData.images" alt="" />
        <img
          @click="closePopBox"
          class="closepxind"
          src="@/assets/img/loginImg/closeRemind.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import { setBaseUrl, gioPlatform, gioJumpType, handleJumpType } from '@/utils/tools';
const pageYear = window.location.pathname.indexOf('ark/home') !== -1 ? 24 : 23;

export default {
  props: {
    popupData: {
      type: Object,
      default: () => {},
    },
    showPopBox: {
      type: Boolean,
    },
    examYear: {
      type: Number,
      default: pageYear,
    },
  },
  data() {
    return {
      dialogVisible: false,
      showImg: '',
      lastTime: null,
    };
  },
  components: {},

  created() {},

  mounted() {},
  watch: {},
  methods: {
    closePopBox() {
      this.$emit('closePopBox');
      this.gioCloseEvent();
    },
    // 请求弹窗数据
    jumpCourseDetail() {
      if (this.lastTime) {
        if (Date.now() - this.lastTime < 1000) return;
      }
      this.gioEvent();
      this.lastTime = Date.now();
      
      // 跳转类型：1.链接；2.产品；3.自定义产品列表；4.产品分类列表
      handleJumpType(this, this.popupData);
    },
    gioEvent() {
      const { title, skipType } = this.popupData;
      // eslint-disable-next-line
      gio('evar.set', 'popUpwindow_evar', title);
      const adId = this.popupData.id;
      // 点击广告埋点
      // eslint-disable-next-line
      gio('track', 'adClick_event', {
        adPosition_var: `${this.examYear}考研-首页-弹窗`, // 广告位置
        pageName_var: '首页', // 页面名称
        adSequence_var: null, // 广告序号
        adId_var: adId.toString(), // 广告ID
        adName_var: title, // 广告名称
        linesBusiness_var: '考研', // 业务线
        jumpType_var: gioJumpType(skipType), // 跳转类型
        platform_var: gioPlatform(),
      });
    },
    gioCloseEvent() {
      const { title, skipType } = this.popupData;
      const adId = this.popupData.id;
      gio('track', 'adClose_event', {
        adPosition_var: `${this.examYear}考研-首页-弹窗`, // 广告位置
        pageName_var: '首页', // 页面名称
        adSequence_var: null, // 广告序号
        adId_var: adId.toString(), // 广告ID
        adName_var: title, // 广告名称
        linesBusiness_var: '考研', // 业务线
        jumpType_var: gioJumpType(skipType), // 跳转类型
        platform_var: gioPlatform(),
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.homePop {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2001;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}
.pxindBox {
  position: absolute;
  top: 22%;
  right: 0;
  left: 0;
  width: 500px;
  height: 644px;
  margin: 0 auto;
}
.pxind {
  width: 100%;
}
.posBtn {
  position: absolute;
  top: 530px;
  right: 0;
  left: 0;
  width: 420px;
  height: 80px;
  margin: 0 auto;
  border-radius: 40px;
}
.closepxind {
  position: absolute;
  right: 0;
  bottom: -100px;
  left: 0;
  width: 58px;
  height: 58px;
  margin: 0 auto;
}
</style>
